<template>
  <div class="row">
    <!--General Top Bar -->
    <!-- <general-top-bar :title="$t('pages.promos')"></general-top-bar> -->
    <!--End General Top Bar -->
    <div class="col-md-12 col-lg-12">
      <div class="search-bar no-margin">
        <div class="col-sm-12 no-padding">
            <div class="pull-left">
              <el-input v-model="filters[0].value" :placeholder="$t('reports.search')" class="icon-search"></el-input>
            </div>
            <div class="pull-right">
              <router-link class="btn add" :title="$t('general.add') + ' ' + $t('marketingCampaigns.single')" :to="{ path: '/marketing/promos/add'}">
                <img src="/static/img/icons/add.png">
                {{ $t('general.add') }}
              </router-link>
            </div>
          </div>
      </div>
      <div class="card">
        <div class="card-content row">
          <data-tables class="width-table campaign-table campaign-table--with-images"
                    v-loading="loading"
                    :data="tableData"
                    :search-def="defaultSearchDef()"
                    :action-def="defaultActionDef()"
                    :pagination-def="paginationDef"
                    :table-props="{'border': false}"
                    :filters="filters"
                    style="width: 100%">
            <el-table-column
              :min-width="45"
              :label="$t('marketingCampaigns.image')">
              <template slot-scope="props">
                <div class="image-table">
                  <img v-bind:src="(props.row.image)?props.row.image : ''" />
                </div>
              </template>
            </el-table-column>
            <el-table-column
              :min-width="60"
              sortable
              prop="title"
              :label="$t('marketingCampaigns.name')">
            </el-table-column>
            <el-table-column
              :min-width="70"
              sortable
              prop="name"
              :label="$t('marketingCampaigns.startEnd')">
              <template slot-scope="props">
                {{formatDate(props.row.date_start)}} - {{formatDate(props.row.date_end)}}
              </template>
            </el-table-column>
            <el-table-column
              :min-width="40"
              sortable
              prop="treshold"
              :label="$t('marketingPromos.treshold')">
              <template slot-scope="props">
                {{props.row.treshold }}
              </template>
            </el-table-column>
            <el-table-column
              :min-width="45"
              :label="$t('marketingCampaigns.status')"
              prop="active">
              <template slot-scope="props">
                <p-switch v-model="props.row.active" type="success" @input="handleActive(props.$index, props.row, $event)"></p-switch>
              </template>
            </el-table-column>
            <el-table-column
              :min-width="70"
              prop="actions"
              class="align-campaign-info"
              :label="$t('marketingCampaigns.actions')">
              <template slot-scope="props">
                <div class="display-flex">
                  <a class="btn delete mar-rt-10" @click="handleDelete(props.$index, props.row)" :title="$t('general.delete')">
                    <img src="/static/img/icons/icon-close.png">
                    {{$t('general.delete')}}
                  </a>
                  <div class="edit" @click="goToRecord(props.row, $event, props.row)">
                      <i class="fa fa-pencil"></i>{{$t('general.edit')}}
                  </div>
                  <template v-if="!props.row.isDisabledByLastSent">
                    <a class="btn btn-icon btn-purple " :title="$t('marketingCampaigns.send')" v-if="props.row.active && props.row.mode == 'MANUAL'"  :disabled="props.row.isDisabledByLastSent" @click="sendNotif(props.$index, props.row)" >
                      <i class="ti-email"></i>
                    </a>
                  </template>
                  <template v-else>
                    <div class="el-upload__tip"> {{$t('marketingCampaigns.campaignWasSent')}}</div>
                  </template>
                </div>
              </template>
            </el-table-column>
          </data-tables>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
  import Vue from 'vue'
  import {Input, Select, Option} from 'element-ui'
  import DataTables from 'vue-data-tables'
  import PSwitch from 'src/components/UIComponents/Switch.vue'
  import PPagination from 'src/components/UIComponents/Pagination.vue'
  // import GeneralTopBar from 'src/components/UIComponents/Inputs/generalTopBar.vue'
  import swal from 'sweetalert2'
  import 'sweetalert2/dist/sweetalert2.css'
  Vue.use(Input)
  Vue.use(Select)
  Vue.use(Option)
  Vue.use(DataTables)
  export default{
    components: {
      PPagination,
      // GeneralTopBar,
      PSwitch
    },
    watch: {
    },
    computed: {
    },
    data () {
      return {
        loading: true,
        actionCol: {
          label: 'Delete',
          props: {
            align: 'center'
          },
          buttons: [{
            props: {
              type: 'danger',
              icon: 'el-icon-delete',
              class: 'btn btn-orange btn-fill'
            },
            handler: (index, row) => {
              this.handleDelete(index, row)
            },
            label: this.$t('general.delete')
          }]
        },
        paginationDef: {
          pageSize: 10,
          currentPage: 1,
          pageSizes: [10, 25, 50],
          show: true
        },
        searchQuery: '',
        propsToSearch: ['title', 'category', 'treshold', 'active'],
        tableColumns: [],
        tableData: [],
        filters: [
          {
            value: '',
            prop: ['title', 'category', 'treshold', 'active']
          }
        ],
        totalEmails: null
      }
    },
    created () {
      this.initPage()

      this.$bus.$on('refresh', this.handleRefresh)
    },
    // mounted () {
    //   this.$bus.$on('refresh', this.handleRefresh)
    // },
    beforeDestroy () {
      this.$bus.$off('refresh', this.handleRefresh)
    },
    methods: {
      handleRefresh () {
        this.initPage()
      },
      initPage () {
        const data = {
          token: this.$session.get('token'),
          company_id: this.$session.get('selectedCompany')
        }

        // Folosim arrow function ca să păstrăm contextul `this`
        this.apiRequest('/promo', 'GET', data, (response) => {
          if (response.status === true) {
            this.tableData = response.data

            this.tableData.forEach((element) => {
              // Vue.set nu mai e nevoie de self/$set, arrow function păstrează contextul
              this.$set(element, 'isDisabledByLastSent', this.checkLastSent(element))
            })
          }

          this.$nextTick(() => {
            this.loading = false
          })
        })
      },
      goToRecord (row, column, event) {
        if (column.property !== 'actions' && column.property !== 'active') {
          this.globalGoToRecord(row, event, column, '/marketing/promos/edit/')
        }
      },
      handleActive (index, row, e) {
        let actionText = row.active ? this.$t('general.activate') : this.$t('general.deactivate')
        swal({
          text: this.$t('validations.areYouSureYouWantTo') + ` ${actionText} ${row.title}?`,
          type: 'question',
          showCancelButton: true,
          confirmButtonText: this.$t('general.yes')
        }).then((result) => {
          if (result) {
            var notificationTypes = []
            for (let i in row.notification_type) {
              if (row.notification_type[i]) {
                for (let type in row.notification_type[i]) {
                  notificationTypes.push({'type': row.notification_type[i][type]})
                }
              }
            }
            var data = {
              token: this.$session.get('token'),
              company_id: this.$session.get('selectedCompany'),
              id: row.id,
              active: row.active ? 1 : 0
            }

            var self = this
            this.apiRequest('/promo/update-status', 'POST', data, function (response) {
              if (response.status) {
                swal(
                  self.$t('general.success') + '!',
                  '',
                  'success'
                ).catch(() => {})
              } else {
                swal(
                  '',
                  self.$t('validations.wentWrong'),
                  'error'
                ).catch(() => {})
                row.active = !row.active
              }
            })
          }
        }).catch(() => {
          row.active = !row.active
        })
      },
      sendNotif (index, row) {
        swal({
          text: this.$t('marketingCampaigns.areYouSureNotif'),
          type: 'question',
          showCancelButton: true,
          confirmButtonText: this.$t('general.yes')
        }).then((result) => {
          this.$nextTick(function () { this.loading = true })
          if (result) {
            var data = {
              token: this.$session.get('token'),
              company_id: this.$session.get('selectedCompany'),
              campaign_id: row.id
            }
            var self = this
            this.apiRequest('/queues/notifications', 'POST', data, function (response) {
              self.$nextTick(function () { this.loading = false })
              if (response.status) {
                swal(
                  '',
                  self.$t('marketingCampaigns.notifSent'),
                  'success'
                ).catch(() => {})
                self.$nextTick(() => {
                  var validIndex = self.tableData.findIndex((obj) => { return obj.id === row.id })
                  self.tableData[validIndex].last_sent = response.data.last_sent
                  self.tableData[validIndex].isDisabledByLastSent = self.checkLastSent(self.tableData[validIndex])
                })
              } else {
                let msg = self.$t('validations.wentWrong')
                if (response.errors.campaign_id !== undefined) {
                  msg = response.errors.campaign_id
                }
                swal(
                  '',
                  msg,
                  'error'
                ).catch(() => {})
              }
            })
          }
        }).catch(() => {
         //
        })
      },
      handleDelete (index, row) {
        var self = this
        var btnCounter = 3
        swal({
          text: this.$t('marketingPromos.areYouSureDelete') + ' ' + row.title + '?',
          type: 'question',
          showCancelButton: true,
          confirmButtonText: this.$t('general.yes') + ' (' + btnCounter + ')'
        })
        .then((result) => {
          if (result) {
            var data = {
              token: this.$session.get('token'),
              company_id: this.$session.get('selectedCompany')
            }
            this.apiRequest('/promo/' + row.id, 'DELETE', data, function (response) {
              if (response.status === true) {
                swal(
                  '',
                  self.$t('marketingPromos.promoDeleted'),
                  'success'
                ).catch(() => {})
                self.tableData.splice(index, 1)
              } else {
                swal(
                  '',
                  self.$t('validations.wentWrong'),
                  'error'
                ).catch(() => {})
              }
            })
          }
        }).catch(() => {
          //
        })
        swal.disableConfirmButton()
        var btnInterval = setInterval(function () {
          btnCounter--

          if (btnCounter >= 1) {
            swal.getConfirmButton().textContent = self.$t('general.yes') + ' (' + btnCounter + ')'
          } else {
            clearInterval(btnInterval)
            swal.getConfirmButton().textContent = self.$t('general.yes')
            swal.enableConfirmButton()
          }
        }, 1000)
      },
      addZero (i) {
        if (i < 10) {
          i = '0' + i
        }
        return i
      },
      checkLastSent (row) {
        if (row.last_sent && row.last_sent.length) {
          const data1 = new Date(row.last_sent)
          const data2 = new Date()
          const differenceInTime = data2.getTime() - data1.getTime()
          const minutes = Math.floor(differenceInTime / 60000)
          if (minutes < 30) {
            return true
          } else {
            return false
          }
        }
        return false
      }
    }
  }
</script>
<style>
</style>



// WEBPACK FOOTER //
// src/components/Dashboard/Views/Marketing/Promos/Promos.vue